/**
 * Valeur affichee par le kit, ou « — » quand elle manque.
 *
 * Regle du back-office (ADR 0024, ADR 0035 §5) : **aucun nombre n'est
 * invente**. Un badge, un indicateur, un compteur d'onglet ou une cellule de
 * tableau qui ne recoit pas de valeur n'affiche ni `0` ni une case vide — un
 * zero se lit comme une mesure, une case vide comme un oubli. Il affiche le
 * tiret, et c'est l'appelant qui dit ailleurs pourquoi la valeur manque.
 *
 * Un nombre est mis en forme a la francaise (espace insecable fine pour les
 * milliers, virgule decimale) ; `NaN` et l'infini sont des absences, pas des
 * valeurs.
 */
export const MISSING_VALUE = '—';

export type DisplayableValue = string | number | null | undefined;

export const displayValue = (value: DisplayableValue): string => {
  if (value === null || value === undefined) {
    return MISSING_VALUE;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value.toLocaleString('fr-FR') : MISSING_VALUE;
  }

  return value.trim() === '' ? MISSING_VALUE : value;
};
